import { NavLink, Outlet } from 'react-router-dom';

// The Management shell.
//
// Grouped rather than scattered because these screens share one property: they
// are the only places in the product that act ACROSS customers. Keeping them
// behind one heading makes that boundary visible, instead of leaving
// cross-tenant powers dotted through an otherwise single-tenant app.

const TABS = [
  { to: '/manage/cancellations', label: 'Cancellations' },
  { to: '/manage/comps', label: 'Comps' },
  { to: '/manage/reconciliation', label: 'Reconciliation' },
  { to: '/manage/tenants', label: 'Tenant controls' },
  { to: '/manage/retention', label: 'Retention' },
  { to: '/manage/audit', label: 'Audit log' },
];

export function ManagementLayout() {
  return (
    <>
      <div className="page-header">
        <h1>Management</h1>
      </div>

      <nav className="toolbar" aria-label="Management sections">
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) => (isActive ? 'primary button-link' : 'button-link')}
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>

      <Outlet />
    </>
  );
}
